/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type HandoffToSalesforceCase from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-case';
import type HandoffToSalesforceTeam from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-team';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import type IntlService from 'ember-intl/services/intl';
import type {
  HandoffOption,
  HandoffOptionGroup,
} from 'embercom/components/workflows/graph-editor/node-items/steps/handoff-to-salesforce-case';

interface Arguments {
  step: HandoffToSalesforceCase | HandoffToSalesforceTeam;
  handoverOptions: HandoffOptionGroup[];
  selectedHandoverOption: HandoffOption | undefined;
  isReadOnly: boolean;
  isLoading: boolean;
  className?: string;
}

type CaseCreationField = {
  name: string;
  description: string;
  quote?: boolean;
  hint?: string;
};
export default class Settings extends Component<Arguments> {
  @service declare intl: IntlService;
  @service declare finStandaloneService: FinStandaloneService;

  get salesforceConfig(): SalesforceConfiguration {
    return this.finStandaloneService.salesforceConfig!;
  }

  get isHandoffToSalesforceCase(): boolean {
    return this.args.step.typeKey === 'handoff-to-salesforce-case';
  }

  get caseCreationFields(): CaseCreationField[] {
    return [
      {
        name: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.subject-field-name',
        ),
        description: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.subject-field-quote',
        ),
        quote: true,
        hint: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.subject-field-hint',
        ),
      },
      {
        name: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.description-field-name',
        ),
        description: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.description-field-quote',
        ),
        quote: true,
      },
      {
        name: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.web-email-field-name',
        ),
        description: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.web-email-quote',
        ),
      },
      {
        name: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.conversation-transcript-field-name',
        ),
        description: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.conversation-transcript-quote',
        ),
      },
      {
        name: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.ai-summary-field-name',
        ),
        description: this.intl.t(
          'operator.workflows.visual-builder.handoff-to-salesforce-case.settings.ai-summary-quote',
        ),
      },
    ];
  }

  @action setHandoffToSalesforceOwnerId(handoffId: string) {
    this.args.step.handoffToSalesforceOwnerId = handoffId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToSalesforceCase::Settings': typeof Settings;
    'workflows/graph-editor/node-items/steps/handoff-to-salesforce-case/settings': typeof Settings;
  }
}
